import { gql } from '@apollo/client';

export const GetUserInfoByTokenQuery = gql`
    query GetInfoByResetPasswordToken($token: String!) {
        getInfoByResetPasswordToken(token: $token) {
            fullName
        }
    }
`;
